var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.757143 11.7429C0.928571 11.9143 1.1 12 1.35714 12C1.61429 12 1.78571 11.9143 1.95714 11.7429L6.5 7.2L11.0429 11.7429C11.2143 11.9143 11.4714 12 11.6429 12C11.8143 12 12.0714 11.9143 12.2429 11.7429C12.5857 11.4 12.5857 10.8857 12.2429 10.5429L7.7 6L12.2429 1.45714C12.5857 1.11429 12.5857 0.6 12.2429 0.257143C11.9 -0.0857143 11.3857 -0.0857143 11.0429 0.257143L6.5 4.8L1.95714 0.257143C1.61429 -0.0857143 1.1 -0.0857143 0.757143 0.257143C0.414286 0.6 0.414286 1.11429 0.757143 1.45714L5.3 6L0.757143 10.5429C0.414286 10.8857 0.414286 11.4 0.757143 11.7429Z",
    fill: "#FF4545"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/Close.a2b6160a.svg";
export { ForwardRef as ReactComponent };